<template>
	<div class="fa-eq-item">
		<div
			class="fa-eq-node"
			:class="{ 'fa-eq-node-branch': !node.isLeaf, 'fa-eq-node-leaf': node.isLeaf }"
		>
			<div class="fa-eq-node-label">{{ node.label }}</div>
			<div
				v-if="node.calculated_value != null && node.calculated_value !== ''"
				class="fa-eq-node-value"
				:class="valueClass"
			>
				{{ formattedValue }}
			</div>
		</div>
		<ul v-if="node.children && node.children.length" class="fa-eq-list">
			<li
				v-for="child in node.children"
				:key="child.label"
				class="fa-eq-li"
			>
				<FaOrgEquationNode :node="child" />
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'FaOrgEquationNode',
	props: {
		node: {
			type: Object,
			required: true,
		},
	},
	computed: {
		parsedValue() {
			const value = this.node && this.node.calculated_value
			if (value === null || value === undefined || value === '') {
				return null
			}
			const num = Number(String(value).trim())
			return Number.isFinite(num) ? num : null
		},
		formattedValue() {
			if (this.parsedValue === null) {
				return '-'
			}
			return this.parsedValue.toFixed(3)
		},
		valueClass() {
			const num = this.parsedValue
			if (num === null) {
				return ''
			}
			if (num <= 5) {
				return 'fa-eq-value-green'
			}
			if (num <= 10) {
				return 'fa-eq-value-yellow'
			}
			return 'fa-eq-value-red'
		},
	},
}
</script>

<style scoped>
.fa-eq-item {
	display: inline-flex;
	flex-direction: column;
	align-items: flex-start;
}

.fa-eq-node {
	position: relative;
	display: inline-block;
	background: #1a5276;
	font-size: 0.68rem;
	font-weight: 700;
	padding: 5px 10px;
	min-width: 96px;
	text-align: center;
	white-space: nowrap;
	box-sizing: border-box;
	line-height: 1.25;
	z-index: 2;
}

.fa-eq-node-label {
	display: block;
}

.fa-eq-node-value {
	display: block;
	margin-top: 2px;
	font-size: 0.72rem;
	font-weight: 700;
}

.fa-eq-value-green {
	color: #4ade80;
}

.fa-eq-value-yellow {
	color: #facc15;
}

.fa-eq-value-red {
	color: #f87171;
}

.fa-eq-node-leaf {
	color: #f1c40f;
}

.fa-eq-node-branch {
	color: #fff;
}

.fa-eq-node-branch::after {
	content: '';
	position: absolute;
	left: 0;
	top: 100%;
	width: 2px;
	height: 10px;
	background: #1a5276;
	z-index: 0;
}

.fa-eq-list {
	list-style: none;
	margin: 0;
	padding: 0;
	position: relative;
}

.fa-eq-li {
	position: relative;
	padding: 10px 0 0 16px;
}

.fa-eq-li::before {
	content: '';
	position: absolute;
	left: 0;
	top: 20px;
	width: 16px;
	height: 2px;
	background: #1a5276;
	z-index: 1;
}

.fa-eq-li::after {
	content: '';
	position: absolute;
	left: 0;
	top: 0;
	width: 2px;
	height: 22px;
	background: #1a5276;
	z-index: 0;
}

.fa-eq-li:first-child::after {
	top: -10px;
	height: 32px;
}

.fa-eq-li:not(:last-child)::after {
	height: 100%;
}

.fa-eq-li:first-child:not(:last-child)::after {
	top: -10px;
	height: calc(100% + 10px);
}
</style>
